// import { inject } from '@angular/core';
import { Route } from '@angular/router';
import {
  NbAuthComponent,
  NbLoginComponent,
  NbLogoutComponent,
  NbRequestPasswordComponent,
  NbResetPasswordComponent,
} from '@nebular/auth';
import { canActivateThemes, canAuthenticated, canUnAuthenticated } from '@res/ngg-core';

export const appRoutes: Route[] = [
  {
    path: '',
    canActivate: [canActivateThemes, canAuthenticated],
    loadChildren: () => import('./pages/pages.routes').then((m) => m.routes),
  },
  {
    path: 'themes',
    loadChildren: () => import('./themes-screen/starter.routes').then((m) => m.routes),
  },
  {
    path: 'auth',
    component: NbAuthComponent,
    providers: [],
    // Only canActivateThemes on the parent: Angular runs parent guards for child activation, so a
    // canUnAuthenticated here bounced signed-in users away from `logout` and left the app with no
    // way to end a session. Each child that must stay anonymous carries the guard itself, as the
    // CRM routing already does.
    canActivate: [canActivateThemes],
    children: [
      {
        path: '',
        component: NbLoginComponent,
        canActivate: [canUnAuthenticated],
      },
      {
        path: 'login',
        component: NbLoginComponent,
        canActivate: [canUnAuthenticated],
      },
      // No `auth/register` route, the same call the CRM already made and for the same reason.
      // NbRegisterComponent creates an ordinary Firebase account with no `admin` claim, and
      // `canAuthenticated` then lets it into the shell, but every collection this app uses
      // (partners, rents, vehicles, lossers) is restricted to isAdmin(), so a self-registered
      // visitor landed in an application whose every list and save Firestore denies. Accounts are
      // provisioned out of band (Firebase console / tools/custom-claim-setter.js). Granting a
      // non-admin role instead would mean designing per-user rules for all four collections,
      // which is a feature, not a fix.
      {
        // Deliberately unguarded: this is the only sign-out affordance, and it is only ever reached
        // by an authenticated user. NbLogoutComponent is inert for anonymous callers.
        path: 'logout',
        component: NbLogoutComponent,
      },
      {
        path: 'request-password',
        component: NbRequestPasswordComponent,
        canActivate: [canUnAuthenticated],
      },
      {
        path: 'reset-password',
        component: NbResetPasswordComponent,
        canActivate: [canUnAuthenticated],
      },
    ],
  },
  // { path: '', redirectTo: 'partners', pathMatch: 'full' },
  { path: '**', redirectTo: '/events' /*, pathMatch: 'full' */ },
];
